<script setup>
import { defineProps, defineModel } from 'vue';
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    label: String,
    items: {
        type: Array,
        default: () => [],
    },
    itemTitle: {
        type: String,
        default: "label",
    },
    itemValue: {
        type: String,
        default: "value",
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    required: {
        type: Boolean,
        default: false
    }
});

const model = defineModel();
const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')
</script>

<template>
    <v-select
        class="field-default"
        v-model="model"
        :label="label || t('common.messages.info.select')"
        :items="items"
        :item-title="itemTitle"
        :item-value="itemValue"
        :multiple="multiple"
        :rules="props.required ? [requiredRule] : []"
        clearable
    />
</template>
